module.exports = __webpack_public_path__ + "static/media/09.54e334a7.png";